// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2jb5j","validationTips":"StatementDescriptor_validationTips__2irKY"};